import axios from '../../httpInstance/axios';
import { CREATE_TRIBE_AND_SCHEDULES_URL } from '../../globals/urls';

const createTribeAndSchedulesService = async (payload) => {
  const response = await axios.post(CREATE_TRIBE_AND_SCHEDULES_URL, payload);
  return response.data;
};

export default createTribeAndSchedulesService;
